import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {noop} from '@republic/foundation/lang/function'
import {isPlainObject} from '@republic/foundation/lang/is'
import {keys} from '@republic/foundation/lang/object'
import Particle from '../Particle'
import Quantum from '../Quantum'
import {load} from '../utils/image-loader'
import {omit} from '../utils/lang'
import {create} from '../utils/style-manager'
import {color, type as colorType} from '../utils/styles/background-color'
import {size, type as sizeType} from '../utils/styles/background-size'
import {repeat, type as repeatType} from '../utils/styles/background-repeat'

const
    getUrl = value => isPlainObject(value) ? value.url : value,

    types = {
        children: PropTypes.node,
        className: PropTypes.string,
        align: PropTypes.string,
        color: colorType,
        image: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.shape({
                url: PropTypes.string.isRequired
            }),
            PropTypes.oneOf([false])
        ]),
        repeat: repeatType,
        size: sizeType
    },

    BackgroundImageAtom = (
        class BackgroundImage extends Component {
            static propTypes = types

            constructor(props) {
                super(props)
                this.loading = false
                this.state = {
                    loaded: false,
                    src: null
                }
            }

            unmounted = false
            destroy = noop

            componentDidUpdate() {
                if (this.state.loaded && getUrl(this.props.image) !== this.state.src) {
                    this.setState({loaded: false})
                }
            }

            addStyle = visible => {
                const
                    url = getUrl(this.props.image),
                    background = {
                        ...this.state.src ?
                            {
                                ...color(this.props.color),
                                ...repeat(this.props.repeat),
                                backgroundImage: `url(${this.state.src})`,
                                backgroundPosition: this.props.align || 'center center',
                                ...size(this.props.size)
                            } :
                            {}
                    },
                    {destroy, style} = create('bits-background-image', this.props, background)

                if (url && visible && !this.loading && !this.state.loaded) {
                    this.loading = true
                    load(url)
                    .then(src => {
                        this.loading = false
                        if (!this.unmounted) {
                            this.setState({loaded: true, src})
                        }
                    })
                    .catch(noop)
                }

                this.destroy()
                this.destroy = destroy
                return style
            }

            componentWillUnmount() {
                this.unmounted = true
                this.destroy()
            }

            render() {
                const
                    {children, color} = this.props,
                    {loaded} = this.state

                return (
                    <Quantum visibility={!loaded}>
                        {({visibility}) => (
                            <Particle
                                {...omit(this.props, keys(types))}
                                {...this.addStyle(visibility)}
                                position={'relative'}>
                                {!visibility && 
                                    <Particle
                                        className={'bits-background-image-cover'}
                                        transition={'opacity 0.5s ease'}
                                        opacity={loaded ? 0 : 1}
                                        color={color || 'white'}
                                        position={'absolute'}
                                        positions={[0,0,0,0]} />}
                                {children}
                            </Particle>
                        )}
                    </Quantum>
                )
            }
        })

export default BackgroundImageAtom
